// backups_view — PURE. How a backup is shown, and what its ledger says at a glance.
import type { BackupManifest, BackupsLedger } from "../api";

/** `2026-09-17 03:15 UTC` from a manifest's taken_at. */
export function backupWhen(takenAt: string): string {
  return new Date(takenAt).toISOString().replace("T", " ").slice(0, 16) + " UTC";
}

/** The user's rows in a backup (the platform's own tables left out). */
export function userRows(tables: Record<string, number>): number {
  return Object.entries(tables).filter(([t]) => t !== "atlas_schema_revisions" && t !== "secrets").reduce((n, [, c]) => n + c, 0);
}

export const REASON_LABEL: Record<BackupManifest["reason"], string> = {
  nightly: "nightly", "before-publish": "before a publication", "before-restore": "before a restore", manual: "manual",
};

/** The night's verdict on the latest backup, in one line — green, red with why, or nothing yet. */
export function nightVerdict(last: BackupsLedger["last"]): { tone: "ok" | "bad" | "none"; text: string } {
  if (!last) return { tone: "none", text: "no nightly run yet" };
  if (!last.ok) return { tone: "bad", text: `last night's backup failed: ${last.error ?? "unknown"}` };
  if (!last.drill) return { tone: "none", text: `backed up ${last.stamp}, not yet proven` };
  if (last.drill.ok) return { tone: "ok", text: `${last.stamp} — restored in a drill and verified` };
  return { tone: "bad", text: `${last.stamp} — the restore drill FAILED: ${[...(last.drill.differences ?? []), last.drill.error ?? ""].filter(Boolean).join("; ")}` };
}
